/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import {
  shape, string, bool, func,
} from 'prop-types';
import { SettingsDeleteAccount as DashboardSettingsPage, Loading as LoadingPage } from '@hyphengroup/cag-components';
import { settingLoginDeleteAccountEvent, withTracking, LOCATIONS } from 'components/tracking';
import withApplicationConfig from 'containers/withApplicationConfig';
import Layout from 'components/layout';
import { CustomerProfileContext } from 'containers/withCustomerProfileContext';
import { withDashboardSettingsPage } from 'containers/withQueries';
import {
  getStaticText, getImages,
  getDashboardDesktopMenuBar,
} from 'helpers/Utils';
import usePageReloadOnHistoryNavigation from 'hooks/usePageReloadOnHistoryNavigation';

function DashboardSettings({
  dashboardSettingsQuery,
  track,
}) {
  if (!dashboardSettingsQuery || dashboardSettingsQuery.loading) {
    return <LoadingPage />;
  }
  const {
    pageConfig: { footer, header }, seoMetadata, refetch, customerProfile,
  } = dashboardSettingsQuery;
  const { logo } = header;
  const staticText = getStaticText(dashboardSettingsQuery);
  const images = getImages(dashboardSettingsQuery);
  const [loading, setLoading] = useState(false);
  const [pageLoading] = usePageReloadOnHistoryNavigation();

  useEffect(() => {
    track({ data: { location: LOCATIONS.DASHBOARD } });
  }, []);

  if (pageLoading) {
    return <LoadingPage />;
  }

  const onDelete = () => {
    if (typeof window === 'undefined'
    || typeof window.zE === 'undefined'
    || typeof window.zE('webWidget:get', 'display') === 'undefined'
    || window.zE('webWidget:get', 'display') === 'hidden'
    ) {
      setLoading(true);
      setTimeout(() => { onDelete(); }, 100);
      return;
    }
    setLoading(false);
    window.zE('webWidget', 'updateSettings', {
      webWidget: {
        chat: {
          suppress: true,
        },
        contactForm: {
          suppress: false,
        },
        helpCenter: {
          suppress: true,
        },
        talk: {
          suppress: true,
        },
        answerBot: {
          suppress: true,
        },
      },
    });
    window.zE.activate();
    window.zE('webWidget:on', 'close', () => {
      window.zE('webWidget', 'updateSettings', {
        webWidget: {
          chat: {
            suppress: false,
          },
          contactForm: {
            suppress: false,
          },
          helpCenter: {
            suppress: false,
          },
          talk: {
            suppress: false,
          },
          answerBot: {
            suppress: false,
          },
        },
      });
    });
  };

  return (
    <Layout
      footer={footer}
      header={header}
      isNavPanelHidden
      onlyForLoggedInUser
      variant="fullScreen"
      seoMetadata={seoMetadata}
      customerProfile={customerProfile}
      staticText={staticText}
      images={images}
      refetch={refetch}
    >
      <CustomerProfileContext.Consumer>
        {({ showMobileMenu, showAccountMenu }) => (
          <div>
            <DashboardSettingsPage
              loading={loading}
              handlers={{
                onLeftIconClick: showMobileMenu,
                onAccountIconClick: showAccountMenu,
                onDelete: () => { settingLoginDeleteAccountEvent(track); onDelete(); },
              }}
              staticText={staticText}
              siteLogo={{
                link: logo?.link?.href,
                imageTitle: logo?.title,
                imageUrl: footer?.logo?.image?.url,
              }}
              desktopMenuBar={getDashboardDesktopMenuBar(staticText)}
            />
          </div>
        )}
      </CustomerProfileContext.Consumer>
    </Layout>
  );
}

DashboardSettings.defaultProps = {
  track: null,
};

DashboardSettings.propTypes = {
  track: func,
  dashboardSettingsQuery: shape({
    loading: bool.isRequired,
    pageConfig: shape({
      footer: shape({
        logo: shape({
          image: shape({
            url: string.isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
      header: shape({
        logo: shape({
          link: shape({
            href: string.isRequired,
          }).isRequired,
          title: string.isRequired,
        }).isRequired,
      }).isRequired,
    }),
  }).isRequired,
};

export default withTracking(
  withApplicationConfig(withDashboardSettingsPage(DashboardSettings), ['languages', 'contentstackKeys'])
);
